<!-- 页面数据出错 -->
<template>
  <div class="box" :style="{height: clientHeight+'px'}">
    <div class="box_content">
      <van-image :width="245" :height="170" lazy-load :src="require('../assets/img/data_empty.png')" />
      <div>{{tipText}}</div>
      <button @click="toPath(btnUrl)">{{btnText}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-null',
  data() {
    return {
    };
  },
  props: {
    tipText: {
      default: () => { return "暂无数据" },
      type: String
    },
    btnText: {
      default: () => { return "去逛逛" },
      type: String
    },
    btnUrl: {
      default: () => { return "" },
      type: String
    }
  },
  mounted() {

  },
  methods: {
    toPath(path) {
      console.log(path, 'pathpath');
      this.$router.replace({
        name: 'HomePage'
      })
      console.log(path, 'pat123hpath');

    }
  },
  computed: {
    clientHeight() {
      return document.body.clientHeight;
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  position: relative;
  .box_content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -80%);
    div {
      font-size: 13px;
      color: rgba(0, 0, 0, 0.6);
      text-align: center;
      margin-top: 33px;
      // margin-bottom: 120px;
    }
    button {
      margin: 0 auto;
      padding: 0;
      border: 1px solid transparent; //自定义边框
      outline: none;
      width: 175px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #2eba73;
      font-size: 15px;
      color: white;
      border-radius: 20px;
      transform: translateY(120px);
    }
  }
}
</style>
